var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useRef, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Badge from '@material-ui/core/Badge';
import Fade from '@material-ui/core/Fade';
import makeStyles from '@material-ui/core/styles/makeStyles';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import clsx from 'clsx';
import { useForm, useLanguage, useDragAndDrop, useFileError, useBaseI18n } from '../hooks';
import { errorGenerators, getFileSource } from '../functions';
import { PictureSvg } from '../images';
import FormHelperText from './FormHelperText';
var imageAccept = ['image/jpg', 'image/png', 'image/jpeg'];
var FormImage = function (_a) {
    var id = _a.id, _b = _a.noDelete, noDelete = _b === void 0 ? false : _b, _c = _a.classes, cl = _c === void 0 ? {} : _c, readonly = _a.readonly;
    var _d = useState(false), isHovering = _d[0], setIsHovering = _d[1];
    var _e = useState("" + Math.random()), fileKey = _e[0], setFileKey = _e[1];
    var fileInputRef = useRef(null);
    var form = useForm();
    var language = useLanguage();
    var fi = useBaseI18n(function (i18n) { return i18n.form.formImage; });
    var fileError = useFileError(id);
    var classes = useStyles({ error: !!fileError });
    var formKey = useMemo(function () { return id + "Path"; }, [id]);
    var imagePath = useMemo(function () { return form.values[formKey]; }, [form.values, formKey]);
    var helperText = useMemo(function () {
        if (!imageAccept.length)
            return undefined;
        var fileTypes = imageAccept.map(function (accept) { return accept.split('/')[1]; });
        return fi.type + " " + fileTypes.join(', ');
    }, [fi]);
    var updateImage = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var image, _a, imagePath;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    files = files !== null && files !== void 0 ? files : [];
                    image = files[0];
                    if (!image)
                        return [2 /*return*/, form.setFieldTouched(id, true)];
                    if (!!imageAccept.includes(image.type)) return [3 /*break*/, 3];
                    _a = !form.touched[id];
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, form.setFieldTouched(id, true)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2: return [2 /*return*/, (_a,
                        form.setFieldError(id, errorGenerators.image(language)))];
                case 3: return [4 /*yield*/, getFileSource(image)];
                case 4:
                    imagePath = _b.sent();
                    form.setValues(function (values) {
                        var _a;
                        return (__assign(__assign({}, values), (_a = {}, _a[id] = image, _a[formKey] = imagePath, _a)));
                    });
                    form.setFieldTouched(id, true);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleInputChange = function (event) {
        updateImage(event.target.files);
    };
    var _f = useDragAndDrop(updateImage), isDragging = _f.isDragging, dragDropProps = __rest(_f, ["isDragging"]);
    var handleHovering = function (boolean) { return function () { return setIsHovering(boolean); }; };
    var handleInputOpen = function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var handleDelete = function () {
        form.setFieldTouched(id, true);
        form.setValues(function (values) {
            var _a;
            return (__assign(__assign({}, values), (_a = {}, _a[id] = null, _a[formKey] = null, _a)));
        });
        setFileKey("" + Math.random());
    };
    return (_jsx("div", __assign({ className: clsx('form-image-main', classes.root, isDragging && classes.dragging, cl.root) }, dragDropProps, { children: _jsxs("div", __assign({ className: classes.rootInner }, { children: [imagePath ? (_jsx(Badge, __assign({ overlap: "rectangle", anchorOrigin: {
                        vertical: 'top',
                        horizontal: 'right'
                    }, classes: {
                        root: cl.badge,
                        badge: classes.badge
                    }, badgeContent: !readonly && (_jsx(Fade, __assign({ "in": isHovering }, { children: _jsxs("div", __assign({ onMouseEnter: handleHovering(true), onMouseLeave: handleHovering(false), className: cl.badge }, { children: [!noDelete && (_jsx(IconButton, __assign({ color: "primary", className: classes.iconButtons, onClick: handleDelete }, { children: _jsx(DeleteIcon, { className: classes.icons }, void 0) }), void 0)),
                                _jsx(IconButton, __assign({ color: "primary", className: classes.iconButtons, onClick: handleInputOpen }, { children: _jsx(EditIcon, { className: classes.icons }, void 0) }), void 0)] }), void 0) }), void 0)) }, { children: _jsx(Avatar, __assign({ alt: "", src: imagePath, variant: "square", className: clsx(classes.container, classes.avatar, cl.avatar), onMouseEnter: handleHovering(true), onMouseLeave: handleHovering(false) }, { children: _jsx(PictureSvg, { className: classes.imageNotFound }, void 0) }), void 0) }), void 0)) : (_jsxs("div", __assign({ className: clsx(classes.container, classes.blank, cl.blank) }, { children: [_jsx(PictureSvg, { className: classes.blankSvg }, void 0),
                        readonly ?
                            _jsx("span", __assign({ className: clsx(classes.blankSpan, classes.text) }, { children: fi.noImage }), void 0)
                            :
                                _jsxs(_Fragment, { children: [_jsx("span", __assign({ className: clsx(classes.blankSpan, classes.text) }, { children: fi.drag }), void 0),
                                        _jsx(Button, __assign({ color: "primary", variant: "outlined", onClick: handleInputOpen, classes: {
                                                root: classes.blankButton,
                                                label: clsx(classes.text, classes.blankButtonLabel)
                                            } }, { children: fi.addImage }), void 0)] }, void 0)] }), void 0)),
                _jsx("input", { ref: fileInputRef, type: "file", className: classes.input, onChange: handleInputChange, accept: imageAccept.join('|') }, fileKey),
                _jsx(FormHelperText, { className: cl.helperText, text: helperText }, void 0),
                _jsx(FormHelperText, { className: cl.error, text: fileError, error: true }, void 0)] }), void 0) }), void 0));
};
export default FormImage;
var useStyles = makeStyles(function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return ({
        root: {
            transition: '0.2s',
            display: 'flex',
            justifyContent: 'center'
        },
        rootInner: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
        },
        dragging: {
            opacity: 0.8,
            transform: 'scale(0.98)',
            '-webkit-transform': 'scale(0.98)',
            '-moz-transform': 'scale(0.98)',
            '-ms-transform': 'scale(0.98)',
            '-o-transform': 'scale(0.98)'
        },
        container: (_a = {
                width: 260,
                height: 260,
                borderRadius: 4,
                background: '#dcdcdc'
            },
            _a[theme.breakpoints.up(1600)] = {
                width: 350,
                height: 350,
                borderRadius: 5
            },
            _a),
        avatar: (_b = {
                border: '0.4px solid #707070'
            },
            _b[theme.breakpoints.up(1600)] = {
                border: '0.5px solid #707070'
            },
            _b),
        badge: {
            transform: 'scale(1) translate(0, 0)',
            height: 'auto'
        },
        icons: {
            background: '#ffffff60',
            borderRadius: '30%',
            padding: 2
        },
        iconButtons: {
            padding: 6,
            marginTop: 4
        },
        blank: (_c = {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingTop: 31,
                paddingBottom: 31,
                '--border-color': function (_a) {
                    var error = _a.error;
                    return error ? theme.palette.error.main : '#acacac';
                },
                backgroundColor: '#f2f2f2',
                backgroundImage: "linear-gradient(to right, var(--border-color) 50%, transparent 50%),\n\t\t\t\t linear-gradient(to right, var(--border-color) 50%, transparent 50%),\n\t\t\t\t linear-gradient(to bottom, var(--border-color) 50%, transparent 50%),\n\t\t\t\t linear-gradient(to bottom, var(--border-color) 50%, transparent 50%)",
                backgroundPosition: 'left top, left bottom, left top, right top',
                backgroundRepeat: 'repeat-x, repeat-x, repeat-y, repeat-y',
                backgroundSize: '11px 1px, 11px 1px, 1px 11px, 1px 11px'
            },
            _c[theme.breakpoints.up(1600)] = {
                paddingTop: 42,
                paddingBottom: 42
            },
            _c),
        blankSvg: {
            width: '40%'
        },
        blankSpan: {
            color: '#BDBDBD'
        },
        text: (_d = {
                fontSize: 12,
                fontFamily: 'Assistant-SemiBold'
            },
            _d[theme.breakpoints.up(1600)] = {
                fontSize: 17
            },
            _d),
        blankButton: (_e = {
                borderRadius: 6.3,
                padding: '3px 13px'
            },
            _e[theme.breakpoints.up(1600)] = {
                borderRadius: 8.5,
                padding: '4.25px 17.85px'
            },
            _e),
        blankButtonLabel: {
            textTransform: 'none'
        },
        input: {
            display: 'none'
        },
        imageNotFound: (_f = {
                transform: 'scale(1.1)'
            },
            _f[theme.breakpoints.down(1600)] = {
                transform: 'scale(1.4)'
            },
            _f)
    });
});
//# sourceMappingURL=FormImage.js.map